/* global axios */
import ApiClient from '../ApiClient';

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, enterprise: true });
  }

  checkout() {
    return axios.post(`${this.url}checkout`);
  }

  subscription() {
    return axios.post(`${this.url}subscription`);
  }

  selectBillingCurrency(currency) {
    return axios.post(`${this.url}select_billing_currency`, { currency });
  }

  getLimits() {
    return axios.get(`${this.url}limits`);
  }

  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(credits) {
    return axios.post(`${this.url}topup_checkout`, { credits });
  }

  // Topup packages for the account's billing currency.
  getTopupOptions() {
    return axios.get(`${this.url}topup_options`);
  }

  // 自托管 Captain 按量付费：用量 + 套餐 + 订单
  getCaptainBilling() {
    return axios.get(`${this.url}captain_billing`);
  }

  // 自托管 Captain 按量付费：购买套餐（易支付），支持月付/年付
  purchaseCaptain(packageKey, payType = 'alipay', billingCycle = 'month') {
    return axios.post(`${this.url}captain_purchase`, {
      package_key: packageKey,
      pay_type: payType,
      billing_cycle: billingCycle,
    });
  }

  // 查询订单支付状态（轮询）
  queryCaptainPayment(orderNo) {
    return axios.get(`${this.url}captain_payment_query`, {
      params: { order_no: orderNo },
    });
  }
}

export default new EnterpriseAccountAPI();
